import {QueryParams} from "../../../shared/queryParams/queryParams";
import { User }      from '@shared/classes/user';

export class StatutBilan {
  constructor() {
    this.invalid = false;
  }

  user: User;
  queryParams: QueryParams;
  invalid: boolean;

}
